import request from '../utils/request';

/**
 * @description: 门店走访列表
 * @param {*} openId 
 */
export function getStoreList(openId) {
    return request({
        url: '/api/inspect/inspectList?openId='+openId,
        method: 'get',
    })
}
/**
 * @description: 门店走访详情
 * @param {*} id 
 */
 export function getStoreDetail(id) {
    return request({
        url: '/api/inspect/inspectDetail?id='+id,
        method: 'get',
    })
}

/**
 * @description: 查询经销商
 * @param {*} params  {dealerName,address}
 */
 export function getDistributor(params) {
    return request({
        url: '/api/inspect/getDealers',
        method: 'get',
        params
    })
}
/**
 * @description: 查询门店列表
 * @param {*} params  {dealerId,storeName}
 */
 export function getStoreNames(params) {
    return request({
        url: '/api/inspect/getStores',
        method: 'get',
        params
    })
}
/**
 * @description: 查询部门列表
 * @param {*} 
 */
 export function getDepts() {
    return request({
        url: '/api/inspect/getDepts',
        method: 'get',
    })
}
/**
 * @description: 效验当前门店是否已督查
 * @param {*} params  {openId,storeName,dealerName}
 */
 export function getCheckInspect(params) {
    return request({
        url: '/api/inspect/checkInspect',
        method: 'get',
        params
    })
}
/**
 * @description: 效验是否需要市区问卷
 * @param {*} params {openId,address}
 */
 export function checkHasQsCity(params) {
    return request({
        url: '/api/inspect/checkHasQsCity',
        method: 'get',
        params
    })
}
/**
 * @description: 提交数据
 * @param {*} data 
 */
 export function addInspect(data) {
    return request({
        url: '/api/inspect/addInspect',
        method: 'post',
        data
    })
}

/**
 * 上传图片，上传Base64返回图片URL
 * @param data {"base":  "ssss"}
 */
export function postUplodBase64(data) {
    return request({
        url: '/api/inspect/uploadBase64',
        method: 'post',
        data,
    })
}